import * as main from "../api/main";
import { call, fork, put, take, takeLatest } from "redux-saga/effects";
import { NavLink, useNavigate } from "react-router-dom";
import mainActions from "../slices/mainSlice";

//배너 리스트
function* requestFetchBannerList(payload) {
  const params = payload.payload;
  const { response, err } = yield call(main.requestBannerList, params);
  if (response) {
    yield put(mainActions.actions.fetchBannerListSuccess(response));
  } else {
    yield put(mainActions.actions.fetchBannerListFailure(err));
  }
}

//제휴아이콘 리스트
function* requestFetchAffiliateIconList(payload) {
  const params = payload.payload;
  const { response, err } = yield call(main.requestAffiliateIconList, params);
  if (response) {
    yield put(mainActions.actions.fetchAffiliateIconListSuccess(response));
  } else {
    yield put(mainActions.actions.fetchAffiliateIconListFailure(err));
  }
}

//제휴사 소개 페이지
function* requestFetchAffiliateList(payload) {
  const params = payload.payload;
  const { response, err } = yield call(main.requestAffiliateList, params);
  if (response) {
    yield put(mainActions.actions.fetchAffiliateListSuccess(response));
  } else {
    yield put(mainActions.actions.fetchAffiliateListFailure(err));
  }
}

export default function* watchMain() {
  yield takeLatest(mainActions.actions.fetchBannerList, requestFetchBannerList);
  yield takeLatest(
    mainActions.actions.fetchAffiliateIconList,
    requestFetchAffiliateIconList
  );
  yield takeLatest(
    mainActions.actions.fetchAffiliateList,
    requestFetchAffiliateList
  );
}
